import React, { useState, useEffect } from 'react';
import { Input } from '@progress/kendo-react-inputs';

const InputDateFilterCell = (props) => {
  const [text, setText] = useState('');

  // Keep input in sync if external filter changes
  useEffect(() => {
    if (props.filter && props.filter.value != null) {
      setText(String(props.filter.value));
    } else {
      setText('');
    }
  }, [props.filter]);

  const handleChange = (e) => {
    const val = e.target.value;
    setText(val); // update input display

    if (val === '') {
      props.onChange({
        value: null,
        operator: '',
        field: props.field,
        syntheticEvent: e
      });
    } else {
      props.onChange({
        value: val,      // pass the typed text
        operator: 'contains', // our CustomProcessor will handle Date -> string
        field: props.field,
        syntheticEvent: e
      });
    }
  };

  return (
    <Input
      type="text"
      value={text}
      onChange={handleChange}
      style={{ width: '100%' }}
    />
  );
};

export default InputDateFilterCell;
